/// <amd-module name="VSSUI/Clipboard" />
export { ClipboardButton } from "./Components/ClipboardButton/ClipboardButton";
export { IClipboardButtonProps } from "./Components/ClipboardButton/ClipboardButton.Props";
export { copyToClipboard } from "./Utils/ClipboardUtils";
